import { toast } from "react-toastify";

const ShowToast = (type, message) => {
    const options = {
        toastId: "custom-id-yes",
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
    };

    if (type === "success") {
        toast.success(message, options);
    } else if (type === "error") {
        toast.error(message, options);
    } else {
        toast.info(message, options);
    }
};

export default ShowToast;
